<div class="trustedGlobalLeaders">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-2 col-md-12">
                <h2>{{ trustedPartnerTitle }}</h2>
            </div>
            <div class="col-lg-10 col-md-12">
                <div class="glide" id="globalTrustedSlider" *ngIf="isBrowser">
                    <div class="glide__track" data-glide-el="track">
                        <ul class="glide__slides">
                            <li class="glide__slide clientLogo" *ngFor="let logo of sliderData.length ? sliderData : defaultSliderData">
                                <img [src]="logo.imgSrc" [alt]="logo.altText" [width]="logo.width" [height]="logo.height" [class]="logo.class">
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>